<template>
  <router-link :to="location">
    <slot>get in touch</slot>
  </router-link>
</template>

<script>
export default {
  computed: {
    location() {
      return {
        path: '/contact',
        query: {
          subject: this.subject
        }
      }
    }
  },
  props: {
    subject: {
      type: String,
      default: ''
    }
  }
}
</script>
